var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8229 13.8384L16.2171 17.2325C16.5295 17.5449 17.036 17.5449 17.3484 17.2325C17.6608 16.9201 17.6608 16.4136 17.3484 16.1011L13.9543 12.707L17.3484 9.31292C17.6608 9.0005 17.6608 8.49397 17.3484 8.18155C17.036 7.86913 16.5295 7.86913 16.2171 8.18155L12.8229 11.5757L9.42883 8.18155C9.11641 7.86913 8.60988 7.86913 8.29746 8.18155C7.98504 8.49397 7.98504 9.0005 8.29746 9.31292L11.6916 12.707L8.29746 16.1011C7.98504 16.4136 7.98504 16.9201 8.29746 17.2325C8.60988 17.5449 9.11641 17.5449 9.42883 17.2325L12.8229 13.8384Z",
    fill: "#FC3B2E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.a3aa00d9ea2dce20429233a871eeecf5.svg";
export { ForwardRef as ReactComponent };